// SettingsPanel.jsx
export function SettingsPanel({ settings, onChange, onClose }) {
  const set = (k, v) => onChange(s => ({ ...s, [k]: v }));

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 520 }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>⚙️ Einstellungen</h2>
          <button className="btn btn-sm" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body" style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>

          <section>
            <div className="section-label" style={{ marginBottom: 10 }}>TED API</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              <label style={{ fontSize: 12, color: 'var(--text3)' }}>API-Key</label>
              <input type="password" value={settings.tedApiKey} onChange={e => set('tedApiKey', e.target.value)} placeholder="Bearer Token von api.ted.europa.eu" />
            </div>
          </section>

          <section style={{ borderTop: '1px solid var(--border)', paddingTop: 16 }}>
            <div className="section-label" style={{ marginBottom: 10 }}>🤖 Jarvis KI-Analyse</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                <input type="checkbox" id="aiEnabled" checked={settings.aiEnabled} onChange={e => set('aiEnabled', e.target.checked)} />
                <label htmlFor="aiEnabled" style={{ fontSize: 13, cursor: 'pointer' }}>KI-Analyse aktivieren</label>
              </div>
              <label style={{ fontSize: 12, color: 'var(--text3)' }}>Endpoint</label>
              <input type="text" value="https://jvs.pa.plus/api" readOnly style={{ opacity: 0.7 }} />
              <label style={{ fontSize: 12, color: 'var(--text3)' }}>API-Key</label>
              <input type="password" value={settings.jarvisApiKey} onChange={e => set('jarvisApiKey', e.target.value)} placeholder="API-Key aus Jarvis → Settings → API Keys" />
              <label style={{ fontSize: 12, color: 'var(--text3)' }}>Modell</label>
              <input type="text" value={settings.jarvisModel} onChange={e => set('jarvisModel', e.target.value)} placeholder="deepseek v4flash" />
            </div>
          </section>

          <section style={{ borderTop: '1px solid var(--border)', paddingTop: 16 }}>
            <div className="section-label" style={{ marginBottom: 10 }}>OpenProject</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <label style={{ fontSize: 12, color: 'var(--text3)' }}>Server-URL</label>
              <input type="text" value={settings.opUrl} onChange={e => set('opUrl', e.target.value)} placeholder="https://opp.one.vision" />
              <label style={{ fontSize: 12, color: 'var(--text3)' }}>API-Key</label>
              <input type="password" value={settings.opApiKey} onChange={e => set('opApiKey', e.target.value)} placeholder="API-Key aus OpenProject → Mein Konto" />
              <label style={{ fontSize: 12, color: 'var(--text3)' }}>Standard-Projekt (Identifier)</label>
              <input type="text" value={settings.opProjectId} onChange={e => set('opProjectId', e.target.value)} placeholder="z.B. 260528-pwk-berlin-whg-sanierung" style={{ fontFamily: 'DM Mono, monospace', fontSize: 12 }} />
            </div>
          </section>

          <section style={{ borderTop: '1px solid var(--border)', paddingTop: 16 }}>
            <div className="section-label" style={{ marginBottom: 10 }}>📁 SharePoint</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <div style={{ fontSize: 11, color: 'var(--text3)', lineHeight: 1.5 }}>
                Site: <strong>onevision365.sharepoint.com/sites/akquise</strong><br />
                Zielordner: <strong>WiP_Öffentlich_Stufe_1</strong>
              </div>
              <label style={{ fontSize: 12, color: 'var(--text3)' }}>Microsoft Graph Access Token</label>
              <input type="password" value={settings.spToken} onChange={e => set('spToken', e.target.value)} placeholder="Token aus Graph Explorer (1h gültig)" />
              <div style={{ fontSize: 11, color: 'var(--text3)' }}>
                → <a href="https://developer.microsoft.com/en-us/graph/graph-explorer" target="_blank" rel="noreferrer" style={{ color: 'var(--accent2)' }}>Graph Explorer öffnen ↗</a> → anmelden → Token kopieren
              </div>
            </div>
          </section>

        </div>
        <div className="modal-footer">
          <button className="btn btn-primary" onClick={onClose}>Speichern & Schließen</button>
        </div>
      </div>
    </div>
  );
}

export default SettingsPanel;
